var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.headerClass},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('nav',[_vm._t("default")],2),(_vm.$store.getters.setPanel && !_vm.isMobile)?_c('BaseView',{attrs:{"header":true}}):_vm._e(),(_vm.isMobile)?_c('BaseView',{attrs:{"header":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }